import {constructUrl, HttpClient} from '../helper/HttpClient';
import {repairRequestQuery, repairResponse, updateRepairRequestQuery} from '../models/repair.model';

export async function getRepairInfo(query: repairRequestQuery): Promise<repairResponse> {
    const url = constructUrl(`laptopRepair?ticketId=${query.ticketId}&serialNumber=${query.serialNumber}`);
    const httpClient = new HttpClient();
    return await httpClient.get<repairResponse>(url);
}


export async function updateRepairInfo(query: updateRepairRequestQuery): Promise<string> {
    const url = constructUrl('laptopRepair');
    const httpClient = new HttpClient();
    return await httpClient.post<string>(url, JSON.stringify(query));
}
